export function formatPhoneNumber(phoneNumber: string) {
  const cleanNumber = phoneNumber?.replace(/\D/g, "");
  if (!cleanNumber) return "";

  const country = "90";
  return `${!cleanNumber.startsWith(country) ? country : ""}${cleanNumber.slice(0, 3)}${cleanNumber.slice(3, 6)}${cleanNumber.slice(6, 9)}${cleanNumber.slice(9)}`;
}
